import React from 'react';
import 'twin.macro';
import { TextLine } from './';

export const Paragraph = ({ children, ...restProps }) => (
  <TextLine text={children} Type='p' tw='opacity-80 leading-relaxed' {...restProps} />
);
